import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./modal.css";

Modal.setAppElement("#root");

const ProjectModal = ({ project, isOpen, onClose }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [isEntering, setIsEntering] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const customStyles = {
    content: {          
      top: 0,
      left: "auto",
      right: 0,
      backgroundColor: "#1f2937",
      border: "none",
      padding: "2rem",
      height: "100%",
      maxHeight: "100%",
      overflow: "auto",
      transform: "translateX(-100%)",
      transition: "transform 0.3s ease-out",
      width:
        width < 640
          ? "70%"
          : width < 768
          ? "60%"
          : width < 1024
          ? "50%"
          : "40%",
      maxWidth: "none",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      transition: "opacity 0.3s ease-out",
    },
  };

  useEffect(() => {
    if (isOpen) {
      setIsEntering(true);
    }

    return () => {
      // cleanup function
      setIsEntering(false);
      setIsExiting(false);
    };
  }, [isOpen]);

  const handleAnimationEnd = () => {
    if (isEntering) {
      setIsEntering(false);
    } else {
      setIsExiting(false);
    }
  };

  const handleRequestClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
      setIsExiting(false);
    }, 300); // set the delay time to match the duration of the exit animation
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      style={customStyles}
      contentLabel="Project Modal"
      closeTimeoutMS={500}
      className={` ${isEntering ? "Modal-enter" : ""} ${
        isExiting ? "Modal-exit" : ""
      }`}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className="text-white">
        <img src={project.image} alt={project.name} className="max-h-25" />
        <div className="font-sans-bold text-xl mb-4 mt-9">{project.name}</div>
        <div className="text-gray-400 mb-4 font-sans text-sm">
          Technology: {project.tech}
        </div>
        {project.link && (
          <div className="flex justify-center">
            <a href={project.link}>
              <button className="text-white border text-xs py-3 px-10 rounded font-sans hover:bg-header hover:text-black hover:-translate-y-1 transition duration-500 ease-in-out">
                Visit Work
              </button>
            </a>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ProjectModal;
